import { useContext } from "react";
import { OrderContext } from "../MainForms/OrderContext";
import { ServicesMultiSelect } from "../../../useCases/contractors/Extensions/CreateContractor/ServicesMultiSelect";
import { useFormContext } from "react-hook-form";
import { Row } from "react-bootstrap";
import { HorizontalView } from "../../Abstractions/HorizontalView";
import { FormControl } from "../../Forms/FormControl";
import { ServicePricingType } from "../../../domain/ServicePricingType";
import { Dropdown } from "../../Abstractions/Dropdown";

export function OrderServicesForm({ fillWasteMass }) {
  const { addressId, transactionType } = useContext(OrderContext) || {};
  const { watch } = useFormContext();
  const fieldName = "wastesDetails.services";
  const services = watch(fieldName);
  // const { isLoading } = wastesDetails || {};
  // const GetFieldName = (name) => `${}.${name}`;
  const GetServiceItemFieldName = (idx) => `${fieldName}[${idx}]`;
  // const services = watch(GetFieldName("wastes"));
  return (
    <>
      <ServicesMultiSelect
        name={fieldName}
        optionSave={(x) => x}
        required={false}
        resetOnReadonlyChange
        skipFieldsTrack={false}
        addressId={addressId}
        transactionType={transactionType}
        isAddressIdRequired
        skipInitLoading
      />
      {fillWasteMass && services?.map((waste, index) => (
        <OrderServiceForm key={index} parentName={GetServiceItemFieldName(index)}/>
      ))}
    </>
  );
}

export function OrderServiceForm({ parentName }) {
  const GetFieldName = (name) => `${parentName}.${name}`;
  return <>
    <div className="my-2">
      <Row>
        <hr></hr>
        <HorizontalView columnsSize={[5,3,3]} className="d-flex gap-2 align-items-start">
          <FormControl name={GetFieldName("name")} label="Usługa" readonly/>
          <Dropdown name={GetFieldName("pricingType")} items={ServicePricingType} label="Jednostka" required={false}/>
          {/*<NumericControl decimalPlaces={4} name={GetFieldName("wasteMass")} label="Masa odpadów [Mg]"/>*/}
        </HorizontalView>
      </Row>
    </div>
  </>;
}